import React from "react";
import { Card } from "./ui/card";
import CountUp from "./ui/CountUp";

export const About = ({ translations, isDark }) => {
    return (
        <section
            id="about"
            className={`min-h-screen py-24 transition-colors duration-300 ${
                isDark ? "bg-zinc-900" : "bg-zinc-50"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div
                                className={`inline-block border-2 px-4 py-2 ${
                                    isDark
                                        ? "border-cyan-400"
                                        : "border-cyan-500"
                                }`}
                            >
                                <span
                                    className={`text-sm uppercase tracking-widest font-mono ${
                                        isDark
                                            ? "text-cyan-400"
                                            : "text-cyan-600"
                                    }`}
                                >
                                    About
                                </span>
                            </div>
                            <h2
                                className={`text-6xl md:text-7xl font-black leading-none tracking-tighter ${
                                    isDark ? "text-white" : "text-zinc-900"
                                }`}
                            >
                                {translations.about.title}
                            </h2>
                            <div
                                className={`h-1 w-24 ${
                                    isDark ? "bg-cyan-400" : "bg-cyan-500"
                                }`}
                            ></div>
                        </div>

                        <p
                            className={`text-xl leading-relaxed ${
                                isDark ? "text-zinc-400" : "text-zinc-700"
                            }`}
                        >
                            {translations.about.description}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-6">
                        {translations.about.stats.map((stat, index) => (
                            <Card
                                key={index}
                                className={`border-2 p-8 transition-all duration-300 group ${
                                    isDark
                                        ? "bg-zinc-950 border-zinc-800 hover:border-cyan-400"
                                        : "bg-white border-zinc-200 hover:border-cyan-500"
                                }`}
                            >
                                <div className="flex items-baseline space-x-4">
                                    <div
                                        className={`text-5xl md:text-6xl font-black font-mono group-hover:scale-110 transition-transform duration-300 ${
                                            isDark
                                                ? "text-cyan-400"
                                                : "text-cyan-600"
                                        }`}
                                    >
                                        <CountUp
                                            from={0}
                                            to={stat.value}
                                            separator=","
                                            direction="up"
                                            duration={1}
                                            className="count-up-text"
                                        />+
                                    </div>
                                    <div
                                        className={`uppercase text-sm tracking-wider flex-1 ${
                                            isDark
                                                ? "text-zinc-400"
                                                : "text-zinc-600"
                                        }`}
                                    >
                                        {stat.label}
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 mt-16 pt-[20dvh]">
                <h3
                    className={`text-6xl md:text-5xl font-black leading-none tracking-tighter ${
                        isDark ? "text-white" : "text-zinc-900"
                    }`}
                >
                    {translations.about.subtitle}
                </h3>
                <div
                    className={`mt-[1.5rem] h-1 w-24 ${
                        isDark ? "bg-cyan-400" : "bg-cyan-500"
                    }`}
                ></div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pt-[2rem]">
                    {translations.about.ratings.map((testimonial) => (
                        <Card
                            key={testimonial.id}
                            className={`group p-6 border-2 transition-all duration-300 ${
                                isDark
                                    ? "bg-zinc-950 border-zinc-800 hover:border-cyan-400"
                                    : "bg-white border-zinc-200 hover:border-cyan-500"
                            }`}
                        >
                            <div className="mb-4">
                                <div
                                    className={`text-2xl font-semibold group-hover:scale-105 transition-transform duration-300 ${
                                        isDark
                                            ? "text-cyan-400"
                                            : "text-cyan-600"
                                    }`}
                                >
                                    {testimonial.name}
                                    {testimonial.company
                                        ? `, ${testimonial.company}`
                                        : ""}
                                </div>
                                <div className="flex items-center mt-2 group-hover:scale-105 transition-transform duration-300">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            className={`w-5 h-5 ${
                                                i < testimonial.rating
                                                    ? isDark
                                                        ? "text-yellow-400"
                                                        : "text-yellow-500"
                                                    : isDark
                                                    ? "text-zinc-700"
                                                    : "text-zinc-300"
                                            }`}
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.974a1 1 0 00.95.69h4.18c.969 0 1.371 1.24.588 1.81l-3.39 2.462a1 1 0 00-.364 1.118l1.286 3.974c.3.921-.755 1.688-1.54 1.118l-3.39-2.462a1 1 0 00-1.176 0l-3.39 2.462c-.784.57-1.838-.197-1.539-1.118l1.286-3.974a1 1 0 00-.364-1.118L2.034 9.4c-.783-.57-.38-1.81.588-1.81h4.18a1 1 0 00.95-.69l1.286-3.974z" />
                                        </svg>
                                    ))}
                                </div>
                            </div>
                            <p
                                className={`text-base leading-relaxed ${
                                    isDark ? "text-zinc-400" : "text-zinc-700"
                                }`}
                            >
                                "{testimonial.review}"
                            </p>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};
